import React, { useRef } from "react";
import "../css/ButtonIconHToday.css";

export default function ButtonIconHToday(props) {
  const inputRef = useRef(null);
  return (
    <button
      className={`button-icon-ver button-today ${
        props.small ? "button-small" : ""
      }`}
      onClick={props.onClick}
      disabled={props.disabled}
      tabIndex={props.tabIndex}
    >
      {props.icon && <div className="svg-icon">{props.icon}</div>}
      <span>{props.text}</span>
      <div
        className="today-arrow"
        onClick={(e) => {
          e.stopPropagation();
          inputRef.current?.showPicker();
        }}
      >
        <img
          src="/images/blue-down-arrow.svg"
          loading="lazy"
          alt="Panel icon"
          className="vectors-wrapper-11"
        />{" "}
      </div>
      <input
        className="hidden-calendar"
        ref={inputRef}
        type="date"
        onChange={(e) => props.onChangeDay(e.target.value)}
      />
    </button>
  );
}
